import { useRouter } from "next/router";

export const useShowPageLoader = () => {
  const { pathname } = useRouter();

  const isInLessonPage =
    pathname?.split("/classwork")[1] === "/[topic_slug]/[activitie_slug]";

  const shouldShowPageLoader = !isInLessonPage;

  return {
    shouldShowPageLoader,
  };
};
